export default function SVGWashing(props: any) {
    return (
        <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <rect x="11.6094" y="6" width="40" height="52" rx="2" stroke="#757575" strokeWidth="2" />
            <path d="M11.6094 22H50.6094" stroke="#757575" strokeWidth="1.77778" strokeLinecap="round" strokeLinejoin="round" />
            <path
                d="M46.7205 14C46.7205 15.7182 45.3276 17.1111 43.6094 17.1111C41.8912 17.1111 40.4983 15.7182 40.4983 14C40.4983 12.2818 41.8912 10.8889 43.6094 10.8889C45.3276 10.8889 46.7205 12.2818 46.7205 14Z"
                stroke="#757575"
                strokeWidth="1.77778"
            />
            <path
                d="M31.6094 51C37.6845 51 42.6094 46.0751 42.6094 40C42.6094 33.9249 37.6845 29 31.6094 29C25.5342 29 20.6094 33.9249 20.6094 40C20.6094 46.0751 25.5342 51 31.6094 51Z"
                stroke="#757575"
                strokeWidth="1.77778"
            />
            <path
                d="M20.6094 40.6938C20.6094 40.6938 25.4157 34.6742 31.4012 40.632C37.3856 46.5908 42.6094 39.4251 42.6094 39.4251"
                stroke="#757575"
                strokeWidth="1.77778"
                strokeLinecap="round"
            />
        </svg>
    );
}
